import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import type { TentsPresence } from "./Player";
import { registerTentsTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type { TentsDefinition, TentsProgress, TentsSolution, TentsSubmission } from "./types";

registerTentsTranslations(i18n);

export const tentsModule: PuzzleTypeModule<
  TentsDefinition,
  TentsSubmission,
  TentsProgress,
  TentsSolution,
  TentsPresence
> = {
  key: "tents",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
